import { load } from "../../events/load";

const initStoryReadMore = () => {
    const readMoreButton = document.querySelector(".story__read-more");
    const hiddenText = document.querySelector(".story__more");

    if (!readMoreButton || !hiddenText) return;

    readMoreButton.addEventListener("click", () => {
        hiddenText.classList.toggle("is-visible");
        readMoreButton.classList.toggle("is-expanded");
        const textElement = readMoreButton.querySelector(".btn__text");

        if (hiddenText.classList.contains("is-visible")) {
            if (textElement) textElement.textContent = "згорнути";
        } else {
            if (textElement) textElement.textContent = "читати більше";
        }
    });
};

load(initStoryReadMore);

